export var TradeCreateOrderError = {
  Grid_Create_Error_Has_Pending: {
    code: -33,
    msg: 'grid_create_error_has_pending'
  },
  Grid_Create_Error_Too_Many_Micro_Order: {
    code: -34,
    msg: 'grid_create_error_too_many_micro_order'
  },
  Grid_Create_Error_Too_Many_Row: {
    code: -36,
    msg: 'grid_create_error_too_many_row'
  },
  Grid_Create_Error_Too_Many_One_Key: {
    code: -37,
    msg: 'grid_create_error_too_many_one_key'
  },
  CustomError: {
    code: -1,
    msg: 'need to modify',
    info: {}
  },
  NetworkError: {
    code: 10000,
    msg: 'network_error'
  },
  NO_Ticker: {
    code: 10001,
    msg: 'trade_grid_get_current_price_failed'
  },
  Balance_Get_Failed: {
    code: 10002,
    msg: 'grid_err_error_none_balances_go'
  },
  Amount_Rather_Than_95_Percent: {
    code: 10003,
    msg: 'ai_rather_than_95_warning'
  },
  Trade_Volume_Little_Than_Min: {
    code: 10004,
    msg: 'trade_order_volume_little_than_market_min',
    info: {
      min_quantity: ''
    }
  },
  NO_Symbol: {
    code: 10005,
    msg: '代码内部报错，应该传入symbol'
  },
  Trade_Need_Price: {
    code: 10006,
    msg: 'trade_tip_input_price'
  },
  Trade_Need_Quantity: {
    code: 10007,
    msg: 'trade_tip_input_quantity'
  },
  Trade_Create_Order_Base_Not_Enough: {
    code: 10008,
    msg: 'trade_create_order_base_not_enough'
  },
  Trade_Create_Order_Quote_Not_Enough: {
    code: 10009,
    msg: 'trade_create_order_quote_not_enough'
  },
  Trade_Create_Order_Insufficient_Balance: {
    code: 10010,
    msg: 'trade_create_order_insufficient_balance'
  },
  Trade_Create_Order_Less_Than_Min_Quantity: {
    code: 10011,
    msg: 'trade_create_order_less_than_min_quantity'
  },
  Trade_Create_Order_Exceed_Max_Quantity: {
    code: 10012,
    msg: 'trade_create_order_exceed_max_quantity'
  },
  Trade_Create_Order_Low_Amount: {
    code: 10013,
    msg: 'trade_create_order_low_amount',
    info: {
      amount: ''
    }
  },
  Trade_Create_Order_Low_Price: {
    code: 10014,
    msg: 'trade_create_order_low_price',
    info: {
      price: ''
    }
  },
  Trade_Create_Order_Low_Cost: {
    code: 10015,
    msg: 'trade_create_order_low_cost',
    info: {
      cost: ''
    }
  },
  Trade_Create_Order_Unresolved_Error: {
    code: 10016,
    msg: 'trade_create_order_unresolved_error',
    info: {
      data: ''
    }
  },
  Trade_Create_Order_No_API_Key: {
    code: 10017,
    msg: 'trade_create_order_get_api_key_failed'
  },
  Trade_Get_Price_Error: {
    code: 10018,
    msg: 'trade_create_order_get_price_failed'
  },
  Trade_Get_OrderBook_Error: {
    code: 10019,
    msg: 'trade_create_order_get_order_book_failed'
  },
  Trade_Balance_Not_Enough: {
    code: 10020,
    msg: 'trade_tip_balance_insufficient'
  },
  Grid_Price_Empty: {
    code: 10100,
    msg: 'trade_grid_check_error_price_empty'
  },
  Grid_Params_Error: {
    code: 10101,
    msg: 'grid_param_err'
  },
  Grid_Price_Rance_Error: {
    code: 10102,
    msg: 'trade_grid_check_error_price_range'
  },
  Grid_Price_Stop: {
    code: 10103,
    msg: 'trade_grid_check_error_price_stop'
  },
  Grid_Count_Error: {
    code: 10104,
    msg: 'grid_row_wrong'
  },
  Grid_per_Volume_Hit_Amount_Min: {
    code: 10105,
    msg: 'grid_err_error_per_volume_hit_amount_min'
  },
  Grid_Get_PerVolume_Error: {
    code: 10106,
    msg: 'grid_per_volume_get_error'
  },
  Grid_AI_Need_Balance_Percent: {
    code: 10107,
    msg: '网格智能交易请求单网格交易量需要传入投资比例'
  },
  Grid__Need_Buy_Base_To_Create_Order: {
    code: 10108,
    msg: 'grid_dialog_content',
    info: {
      baseInfo: '',
      result: {}
    }
  },
  Grid__Need_Sell_Base_To_Create_Order: {
    code: 10109,
    msg: 'grid_dialog_content_1',
    info: {
      baseInfo: '',
      result: {}
    }
  },
  Grid_Trade_Count_Too_Large: {
    code: 10110,
    msg: 'grid_trade_same_price'
  },
  Grid_Trade_Price_Offset_Too_Large: {
    code: 10111,
    msg: 'grid_request_error_grid_price_hit_price_min'
  },
  Grid_Trade_PerVolume_Too_Small: {
    code: 10112,
    msg: 'grid_err_error_grid_cost_hit_cost_min'
  },
  Grid_Trade_Unknow_Error: {
    code: 10113,
    msg: 'grid_err_error_add_balanced_monitor_error'
  },
  Grid_Trade_Price_Is_Too_Broad: {
    code: 10114,
    msg: 'grid_error_price_is_too_broad'
  },
  Grid_Trade_Exchange_Busy: {
    code: 10115,
    msg: 'grid_error_exchange_busy'
  },
  Grid_Trade_Sign_Failed: {
    code: 10116,
    msg: 'grid_error_sign_failed'
  },
  Grid_Trade_Base_Not_Enough: {
    code: 10117,
    msg: 'grid_err_error_balance_not_enough_base',
    info: {
      base: ''
    }
  },
  Grid_Trade_Quote_Not_Enough: {
    code: 10118,
    msg: 'grid_err_error_balance_not_enough_quote',
    info: {
      quote: ''
    }
  },
  Grid_Trade_Both_Balance_Not_Enough: {
    code: 10119,
    msg: 'grid_err_error_balance_not_enough_both_side',
    info: {
      base: '',
      quote: ''
    }
  },
  Grid_Trade_Get_Balance_Error: {
    code: 10120,
    msg: 'grid_err_error_in_get_balance'
  },
  Grid_Error_In_Place_Grid_Balance_Order: {
    code: 10121,
    msg: 'grid_err_error_in_place_grid_balance_order'
  },
  Grid_Error_In_Wait_Sell_Grid_Balance: {
    code: 10122,
    msg: 'grid_err_error_in_wait_sell_grid_balance'
  },
  Grid_Error_In_Grid_Stop_Loss: {
    code: 10123,
    msg: 'grid_err_error_in_grid_stop_loss'
  },
  Grid_Error_In_Cancel_Orders: {
    code: 10124,
    msg: 'grid_err_error_in_cancel_orders'
  },
  Grid_Error_In_Place_Grid_Orders: {
    code: 10125,
    msg: 'grid_err_error_in_place_grid_orders'
  },
  Grid_Error_In_Wait_Order_Done: {
    code: 10126,
    msg: 'grid_err_error_in_wait_order_done'
  },
  Grid_Error_Got_None_Check_Grids: {
    code: 10127,
    msg: 'grid_err_error_in_wait_order_done'
  },
  Grid_Error_Not_Found_Cross_Order: {
    code: 10128,
    msg: 'grid_err_error_in_wait_order_done'
  },
  Grid_Error_Got_None_Cb_Info: {
    code: 10129,
    msg: 'grid_err_error_in_wait_order_done'
  },
  Grid_Error_Got_Unknown_Cb_Action: {
    code: 10130,
    msg: 'grid_err_error_got_unknown_cb_action'
  },
  Grid_Error_Add_Not_Balanced_Monitor: {
    code: 10131,
    msg: 'grid_err_error_add_not_balanced_monitor_error'
  },
  Grid_Error_Stop_In_Loss: {
    code: 10132,
    msg: 'grid_err_error_stop_in_loss'
  },
  Grid_Error_Balance_Not_Enough_In_Runtime: {
    code: 10133,
    msg: 'grid_err_error_balance_not_enough_in_run_time'
  },
  Grid_Error_Got_Unknown_Order_Id: {
    code: 10134,
    msg: 'grid_err_error_got_unknown_order_id'
  },
  Grid_Grids_Count_Empty: {
    code: 10135,
    msg: 'trade_grid_check_error_grids_count_empty'
  },
  Grid_High_Too_High: {
    code: 10136,
    msg: 'error_grid_high_price_is_too_high'
  },
  Grid_Low_Too_Low: {
    code: 10137,
    msg: 'error_grid_low_price_is_too_low'
  },
  TSL_Input_Trailing_Perent_Error: {
    code: 10200,
    msg: 'trailing_stop_limit_error_input_trailing_percent'
  },
  TSL_Buy_Price_Null: {
    code: 10201,
    msg: 'trailing_stop_limit_error_input_buy_price'
  },
  TSL_Input_Trailing_Percent_Too_Big: {
    code: 10202,
    msg: 'trailing_stop_limit_recommend_trailing_percent',
    info: {
      result: {}
    }
  },
  TSL_Input_Quantity_Null: {
    code: 10203,
    msg: 'trailing_stop_limit_error_input_quantity'
  },
  TSL_Input_Sell_Trigger_Null: {
    code: 10205,
    msg: 'trailing_stop_limit_error_input_trigger_price'
  },
  AIP_Investment_Per_Volume_Null: {
    code: 10301,
    msg: 'aip_investment_per_volume_null'
  },
  AIP_Get_Symbol_Failed: {
    code: 10302,
    msg: 'aip_create_order_get_current_symbol_failed'
  },
  AIP_Per_Volume_Small_Than_Min_Cost: {
    code: 10303,
    msg: 'aip_per_volume_small_than_min_cost'
  },
  AIP_Balance_Not_Enough_To_Spend_A_Week: {
    code: 10304,
    msg: 'aip_balance_not_enough_to_spend_a_week'
  },
  Market_Order_Not_Support: {
    code: 10400,
    msg: 'market_order_not_support'
  },
  IG_INSUFFICIENT_INVEST: {
    code: 10501,
    msg: 'IG_INSUFFICIENT_INVEST_ERROR',
    info: {
      min: ''
    }
  },
  IG_INSUFFICIENT_FUNDS: {
    code: 10502,
    msg: 'IG_INSUFFICIENT_FUNDS_ERROR',
    info: {
      min: ''
    }
  },
  IG_BAD_BALANCE_ORDER: {
    code: 10503,
    msg: 'IG_BAD_BALANCE_ORDER',
    info: {}
  },
  IG_Bottom_Empty: {
    code: 10504,
    msg: 'ig_trading_please_input_bottom'
  },
  IG_Investment_Empty: {
    code: 10505,
    msg: 'ig_trading_please_input_investment'
  },
  IG_Rate_Empty: {
    code: 10506,
    msg: 'ig_trading_please_input_rate'
  },
  IG_Rate_Range_Error: {
    code: 10507,
    msg: 'ig_trading_rate_range_error'
  },
  IG_OUT_OF_BOUNDS: {
    code: 10508,
    msg: 'ig_trading_out_of_bounds_error'
  },
  Trade_Create_Order_out_of_leverage_market_amount: {
    code: 10509,
    msg: 'trade_cost_than_leverage_amount',
    info: {
      amount: 0
    }
  },
  Trade_Create_Order_out_of_leverage_account_amount: {
    code: 10510,
    msg: 'trade_cost_than_leverage_pair_limit',
    info: {
      amount: 0
    }
  }
};